import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import rightArrow from "../../assets/images/right-arrow.png";

const portfolioData = [
  {
    title: "Shining Qualities",
    description: "A Diamond Marketplace that can processes 1m+ Diamonds/day.",
    imageSrc: "/images/case-study/shining-qualities-index.webp",
    link: "/case-studies/diamond-marketplace-development",
  },
  {
    title: "Vaccine Passport Platform",
    description: "Secure Vaccine Passport Platform to streamline post COVID Travel & Access.",
    imageSrc: "/images/case-study/vaccine.webp",
    link: "/case-studies/vaccine-healthcare-development",
  },
  {
    title: "Custom ChatGPT ChatBot",
    description: "Custom ChatGPT ChatBot that is trained on your personal documents and content.",
    imageSrc: "/images/case-study/custom-chatbot.webp",
    link: "/case-studies/custom-chatbot-develeopment",
  },
];

const CaseStudyCard = ({ title, description, imageSrc, link, index }) => {
  const marginTopClasses = ["lg:mt-0", "lg:mt-[-40px]", "lg:mt-[-80px]"];
  return (
    <div
      className={`flex flex-col pb-6 mx-auto w-full bg-gray-50 rounded-xl overflow-hidden border border-gray-200 border-solid ${marginTopClasses[index]}`}
    >
      <img
        loading="lazy"
        src={imageSrc}
        alt={title}
        className="max-w-full w-auto h-auto max-h-[200px] object-cover aspect-[2]"
      />

      <h3 className="mx-6 mt-6 text-2xl font-medium leading-normal text-gray-900 max-md:mx-2.5">
        {title}
      </h3>
      <p className="mx-6 mt-2.5 text-base leading-relaxed text-gray-700 max-md:mx-2.5">
        {description}
      </p>
      <Link
        to={link}
        className="flex items-center gap-2.5 self-start mt-5 ml-6 text-base font-medium leading-normal rounded-lg text-gray-900 max-md:ml-2.5"
      >
        <span>View Case Study</span>
        <img loading="lazy" src={rightArrow} className="mt-0.5 h-2.5 w-5" alt="right arrow" />
      </Link>
    </div>
  );
};

const Portfolio = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth >= 640 && window.innerWidth <= 1023);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const displayedPortfolioData = isTablet ? portfolioData.slice(0, 2) : portfolioData;

  return (
    <section className="lg:pt-[100px] sm:pt-16 pt-12 lg:pb-[100px] sm:pb-16 pb-12 lg:px-7 px-5">
      <div className="container max-w-7xl mx-auto">
        <div className="lg:mb-14 sm:mb-10 mb-7">
          <h2 className="lg:text-[44px] sm:text-[40px] text-3xl font-semibold text-gray-900 leading-tight pb-px">
            Portfolio of Innovation
          </h2>
          <p className="mt-5 text-lg leading-[29px] text-gray-700 max-w-[420px]">
            Discover how we've helped companies achieve their goals through our expertise.
          </p>
        </div>
        <div>
          <div className="max-md:max-w-full">
            <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 md:gap-10 sm:gap-8 gap-7">
              {displayedPortfolioData.map((item, index) => (
                <div key={index} className="flex flex-col">
                  <CaseStudyCard {...item} index={index} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
